export const FOOD_TYPES = {
  buffet_dish: 'buffet_dish',
  normal_dish: 'normal_dish',
}

export const MAX_BUFFET_ORDER = 2
